import React from "react";
import { t } from "@client/lib/dictionary";
import type { PipDeviceInfo, PipListItem } from "@client/types/pip";
import { Card, CardContent, CardHeader, CardTitle } from "@client/components/ui/card";

interface Props {
  record: PipListItem | undefined;
  deviceInfo: PipDeviceInfo | null | undefined;
}

const Row: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
  <div className="flex justify-between gap-4 py-1.5 border-b border-border/50 last:border-0">
    <span className="text-muted-foreground text-sm">{label}</span>
    <span className="font-mono text-sm text-right">{value || "—"}</span>
  </div>
);

export const PipDeviceInfoCard: React.FC<Props> = ({ record, deviceInfo }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t.pip.detail.deviceInfo}</CardTitle>
      </CardHeader>
      <CardContent>
        <Row label="Protokol" value={deviceInfo?.protocolId ?? record?.protocolVariant ?? "—"} />
        <Row label="Sériové číslo" value={deviceInfo?.serialNumber} />
        <Row label="Hlavní firmware" value={deviceInfo?.mainFirmwareVersion} />
        <Row label="Sekundární firmware" value={deviceInfo?.secondaryFirmwareVersion} />
        <Row label="Typ zařízení" value={deviceInfo?.machineType} />
        <Row label="Topologie" value={deviceInfo?.topology} />
        <Row label="Output mode" value={deviceInfo?.outputMode} />
        <Row label="Max. paralelně" value={deviceInfo?.parallelMaxNumber ?? 1} />
        {record && (
          <>
            <Row label="Slug" value={record.slug} />
            <Row label="Transport" value={`${record.transportType} (${record.transportTarget})`} />
            <Row label="Baud rate" value={`${record.baudRate} 8N1`} />
            <Row label="Typ baterie" value={record.batteryType} />
            <Row label="Nominální V baterie" value={`${record.batteryNominalV} V`} />
          </>
        )}
      </CardContent>
    </Card>
  );
};
